<div class="printable">
  <authority-labs-base-certificate-details
    [order]="order"
    [project]="project"
    [subProject]="subProject"
    [company]="company"
    [contact]="contact"
    [assignee]="assignee"
    [approval]="approval"
    [inspection]="inspection"
    [systemDescription]="'בדיקת אופין רשת מים'"
    [title]="title"
    [subTitle]="subTitle"
  ></authority-labs-base-certificate-details>

  <div class="page-break"></div>

  <authority-labs-certificate-water-network-characterization
    *ngIf="inspection?.inspectionWaterNetworkCharacterization?.isApplicable"
    [inspection]="inspection.inspectionWaterNetworkCharacterization"
    [inspectionDate]="inspection.inspectionDate"
  >
  </authority-labs-certificate-water-network-characterization>

  <p style="text-align: center">
    <strong style="font-size: 5pt; position: relative; top: -5px"
      >&#10033;</strong
    >
    <strong style="font-size: 14pt">סוף דו"ח בדיקה</strong>
    <strong style="font-size: 5pt; position: relative; top: -5px"
      >&#10033;</strong
    >
  </p>
</div>
